import { ChangeEvent } from 'react'
import { Props } from './interfaces'
import * as Styled from './styled'

function Checkbox({ register, label, name, alignItems, height, ...props }: Props) {
  const reactHookFormProps = register?.(name)

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.onChange?.(event)
    return reactHookFormProps?.onChange(event)
  }

  return (
    <>
      <Styled.Label alignItems={alignItems} height={height}>
        {label}
        <Styled.Checkbox
          type="checkbox"
          {...reactHookFormProps}
          {...props}
          onChange={handleChange}
        />
        <Styled.Checkmark />
      </Styled.Label>
    </>
  )
}

Checkbox.defaultProps = {
  disabled: false,
}

export default Checkbox
